import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { Loader } from '../components/Loader';
import { Error } from '../components/Error';

import { TransitionWrapper } from '../components/TransitionWrapper';
import PageArticle from '../components/PageArticle';

const GET_PAGE = gql`
  query getPage($slug: String!, $exclude: [Int]) {
    pages: getWPPages(slug: [$slug], exclude: $exclude, status: ["publish"]) {
      id
      status
      title {
        rendered
      }
      excerpt {
        rendered
      }
      content {
        rendered
      }
      embedded {
        featuredmedia {
          media_details {
            file
          }
        }
      }
      acf
    }
  }
`;

export default function Page({ path, history }) {
  // Get the last part of the path (Ignores the trailing slash).
  const slug = path.match(/([^/]*)\/*$/)[1];

  return (
    <TransitionWrapper>
      <Query
        query={GET_PAGE}
        variables={{
          slug: slug,
          exclude: Number(process.env.REACT_APP_FRONT_PAGE_ID)
        }}
      >
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }

          if (error) {
            return <Error error={error} />;
          }

          if (!data.pages || data.pages.length === 0) {
            history.replace('/404');

            return null;
          }

          return <PageArticle page={data.pages[0]} />;
        }}
      </Query>
    </TransitionWrapper>
  );
}

Page.propTypes = {
  path: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired
};
